/* Overrides and functionality related to SCHEMAFORMS.IO */
import angular from 'angular';
import $ from 'jquery';

import fileUploadHtmlUrl from 'ioToolViews/directives/forms/fileUpload.html';
import creativeHtmlUrl from 'ioToolViews/directives/forms/creative.html';
import datePickerHtmlUrl from 'ioToolViews/directives/forms/datePicker.html';
import formConstantHtmlUrl from 'ioToolViews/directives/forms/formConstant.html';
import dynamicCalculationsHtmlUrl from 'ioToolViews/directives/forms/dynamicCalculations.html';
import commentsHtmlUrl from 'ioToolViews/directives/forms/comments.html';
import timePickerHtmlUrl from 'ioToolViews/directives/forms/timePicker.html';
import phoneNumberHtmlUrl from 'ioToolViews/directives/forms/phoneNumber.html';
import currencyPickerHtmlUrl from 'ioToolViews/directives/forms/currencyPicker.html';
import integerPickerHtmlUrl from 'ioToolViews/directives/forms/integerPicker.html';
import decimalPickerHtmlUrl from 'ioToolViews/directives/forms/decimalPicker.html';
import hyperlinkPickerHtmlUrl from 'ioToolViews/directives/forms/hyperlinkPicker.html';
import percentagePickerHtmlUrl from 'ioToolViews/directives/forms/percentagePicker.html';
import timeZoneHtmlUrl from 'ioToolViews/directives/forms/timeZone.html';
import locationPickerHtmlUrl from 'ioToolViews/directives/forms/locationPicker.html';
import locationPickerFbHtmlUrl from 'ioToolViews/directives/forms/locationPickerFb.html';
import geoLocationHtmlUrl from 'ioToolViews/directives/forms/geoLocation.html';
import emojiPickerHtmlUrl from 'ioToolViews/directives/forms/emojiPicker.html';
import locationTargetingHtmlUrl from 'ioToolViews/directives/forms/locationTargeting.html';
import audienceTargetingHtmlUrl from 'ioToolViews/directives/forms/audienceTargeting.html';
import audienceSegmentsHtmlUrl from 'ioToolViews/directives/forms/audienceSegments.html';
import serviceMapperHtmlUrl from 'ioToolViews/directives/forms/serviceMapper.html';
import adGroupHtmlUrl from 'ioToolViews/directives/forms/adGroup.html';
import dfpWidgetHtmlUrl from 'ioToolViews/directives/forms/dfpWidget.html';
import dfpFrequencyHtmlUrl from 'ioToolViews/directives/forms/dfpFrequency.html';
import deviceTargetingHtmlUrl from 'ioToolViews/directives/forms/deviceTargeting.html';
import dfpAdUnitsHtmlUrl from 'ioToolViews/directives/forms/dfpAdUnits.html';
import uiselect2HtmlUrl from 'ioToolViews/directives/forms/uiselect2.html';
import uiMultiSelectCustomHtmlUrl from 'ioToolViews/directives/forms/uimultiselectcustom.html';
import ioTextAreaHtmlUrl from 'ioToolViews/directives/forms/ioTextArea.html';
import ioTextplainAreaHtmlUrl from 'ioToolViews/directives/forms/ioTextplainArea.html';
import dayPartingHtmlUrl from 'ioToolViews/directives/forms/dayPartyTargeting.html';
import connectionTargetingHtmlUrl from 'ioToolViews/directives/forms/connectionTargeting.html';
import multipleMappingsHtmlUrl from 'ioToolViews/directives/forms/multipleMappings.html';
import mobileApplicationHtmlUrl from 'ioToolViews/directives/forms/mobileApplications.html';
import deviceCapabilityHtmlUrl from 'ioToolViews/directives/forms/deviceCapability.html';
import inventoryFilterHtmlUrl from 'ioToolViews/directives/forms/inventoryFilter.html';
import adScheduleHtmlUrl from 'ioToolViews/directives/forms/adScheduleTargeting.html';
import shoppingAdgroupSingleProductHtmlUrl from 'ioToolViews/directives/forms/shoppingAdgroupSingleProduct.html';
import shoppingAdgroupMultiproductHtmlUrl from 'ioToolViews/directives/forms/shoppingAdgroupMultiproduct.html';
import facebookAdsLocationHtmlUrl from 'ioToolViews/directives/forms/facebookAdsLocation.html';
import snapchatAdsLocationHtmlUrl from 'ioToolViews/directives/forms/snapchatAdsLocation.html';
import xandrInvestLocationHtmlUrl from 'ioToolViews/directives/forms/xandrInvestLocation.html';
import facebookAdsFrequencyHtmlUrl from 'ioToolViews/directives/forms/facebookAdsFrequency.html';
import pinterestAdsFrequencyHtmlUrl from 'ioToolViews/directives/forms/pinterestAdsFrequency.html';
import ageTargetingHtmlUrl from 'ioToolViews/directives/forms/ageTargeting.html';
import snapChatAgeTargetingHtmlUrl from 'ioToolViews/directives/forms/snapChatAgeTargeting.html';
import facebookCreateAdsHtmlUrl from 'ioToolViews/directives/forms/facebookCreateAds.html';
import geoTargetingGoogleHtmlUrl from 'ioToolViews/directives/forms/geoTargetingGoogle.html';
import metricSelectHtmlUrl from 'ioToolViews/directives/forms/metricSelect.html';
import contentLinksHtmlUrl from 'ioToolViews/directives/forms/contentLinks.html';
import bridgeEmailTestHtmlUrl from 'ioToolViews/directives/forms/bridgeEmailTest.html';
import googleAdsBiddingHtmlUrl from 'ioToolViews/directives/forms/googleAdsBidding.html';
import fbAudienceHtmlUrl from 'ioToolViews/directives/forms/facebookAudienceTargeting.html';
import snapGenderHtmlUrl from 'ioToolViews/directives/forms/snapGender.html';
import customMacroMappingHtmlUrl from 'ioToolViews/directives/forms/customMacroMapping.html';
import customMacroMapping2HtmlUrl from 'ioToolViews/directives/forms/customMacroMapping2.html';
import seedListMacrosHtmlUrl from 'ioToolViews/directives/forms/seedListMacros.html';
import posMatchbackDetailsHtmlUrl from 'ioToolViews/directives/forms/posMatchbackDetails.html';
import advancedDemographicsHtmlUrl from 'ioToolViews/directives/forms/advancedDemographics.html';
import pinterestAudienceHtmlUrl from 'ioToolViews/directives/forms/pinterestAudienceTargeting.html';
import linkedinAudienceHtmlUrl from 'ioToolViews/directives/forms/linkedinAudienceTargeting.html';
import googleAdsExtensionHtmlUrl from 'ioToolViews/directives/forms/googleAdsExtension.html';
import snapChatFrequencyHtmlUrl from 'ioToolViews/directives/forms/snapChatFrequency.html';
import xandrInvestFrequencyHtmlUrl from 'ioToolViews/directives/forms/xandrInvestFrequency.html';
import tritonAdsFrequencyHtmlUrl from 'ioToolViews/directives/forms/tritonAdsFrequency.html';
import tritonTeamsHtmlUrl from 'ioToolViews/directives/forms/tritonTeamsList.html';
import yelpCategoriesHtmlUrl from 'ioToolViews/directives/forms/yelpCategoriesList.html';
import snapPredefinedAudiencesHtmlUrl from 'ioToolViews/directives/forms/snapPredefinedAudiences.html';
import tiktokAudienceHtmlUrl from 'ioToolViews/directives/forms/tiktokAudienceTargeting.html';
import tiktokDeviceHtmlUrl from 'ioToolViews/directives/forms/tiktokDeviceTargeting.html';
import tiktokLanguagesHtmlUrl from 'ioToolViews/directives/forms/tiktokLanguagesTargeting.html';
import imageUploadHtmlUrl from 'ioToolViews/directives/forms/imageUpload.html';
import linksAndMainCtaHtmlUrl from 'ioToolViews/directives/forms/linksAndMainCta.html';
import googleAdManagerAvailUnitsUrl from 'ioToolViews/directives/forms/googleAdManagerAvailUnit.html';
import facebookAudiencesHtmlUrl from 'ioToolViews/directives/forms/facebookAudiences.html';
import finalApprovalHtmlUrl from 'ioToolViews/directives/forms/finalApproval.html';
import pinterestGeoLocationUrl from 'ioToolViews/directives/forms/pinterestGeoLocation.html';
import facebookPageIdHtmlUrl from 'ioToolViews/directives/forms/facebookPageId.html'
import tritonListenerTargetingHtmlUrl from 'ioToolViews/directives/forms/tritonListenerTargeting.html';
import tritonGeoTargetingHtmlUrl from 'ioToolViews/directives/forms/tritonGeoTargeting.html';
import tritonCreativeManagementHtmlUrl from 'ioToolViews/directives/forms/tritonCreativeManagement.html';
import linkedinGeoTargetingHtmlUrl from 'ioToolViews/directives/forms/linkedinGeoTargeting.html';
import tritonTimeTargetingHtmlUrl from 'ioToolViews/directives/forms/tritonTimeTargeting.html';
import tritonContentTargetingHtmlUrl from 'ioToolViews/directives/forms/tritonContentTargeting.html';
import snapchatPixelControlsHtmlUrl from 'ioToolViews/directives/forms/snapchatPixelsList.html';
import pinterestKeywordHtmlUrl from 'ioToolViews/directives/forms/pinterestKeyword.html';
import accountabilityGroupLabelHtmlUrl from 'ioToolViews/directives/forms/accountabilityGroupLabel.html';
import linkedinCampaignObjectiveHtmlUrl from 'ioToolViews/directives/forms/linkedinCampaignObjective.html';
import tiktokGeoTargetingHtmlUrl from 'ioToolViews/directives/forms/tiktokGeoTargeting.html';


angular.module('schemaForm')
    .config(['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
        function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
            schemaFormDecoratorsProvider.addMapping(
                'bootstrapDecorator',
                'dfFile',
                fileUploadHtmlUrl
            );

            schemaFormDecoratorsProvider.createDirective(
                'dfFile',
                fileUploadHtmlUrl
            );
        }
    ])
    .controller('fileUploadController', ['$scope', '$http', '$ioAlert', function ($scope, $http, $ioAlert) {

        $scope.validate = function (fileModal, index) {
            var file_name = '';
            if (fileModal[index]) {
                file_name = fileModal[index].name;
            } else if (fileModal.file_name) {
                file_name = fileModal.file_name;
            }
            var validFilename = /^[A-Za-z0-9_.@()-\s]+\.[^.]+$/i.test(file_name);
            if (!validFilename) {
                console.log('Warning, filename contains metacharacters.');
            }
        }

        $scope.deleteFile = function (fileModal, index) {
            fileModal.splice(index, 1);
        }

        $scope.deleteCustomFile = function (fileModal) {
        }
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'creative',
                    creativeHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'creative',
                    creativeHtmlUrl
                );
            }
        ])
    .controller('creativeController', ['$scope', 'ModalService', 'creativesService', 'ClusterService', '$ioAlert', function ($scope, ModalService, creativesService, ClusterService, $ioAlert) {

        $scope.addCreative = function (model, clientId, form) {
            if (clientId) {
                var data = {
                    "clientId": clientId,
                    "model": model
                };
                var field_name = (form && form.field_name) ? form.field_name : 'creativelibrary';
                ModalService.returnModalType('creativeLibrary', data).result.then(function (formObj) {
                    $scope.model[field_name] = formObj;
                }, function (cancel) {
                    console.log("cancel");
                });
            } else {
                $ioAlert.show("Error", "Please select client");
            }
        };

        $scope.deleteFile = function (fileModal, index) {
            fileModal = fileModal.splice(index, 1);
        }

    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'datePicker',
                    datePickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'datePicker',
                    datePickerHtmlUrl
                );
            }
        ])
    .controller('ioDatePickerController', ['$scope', function ($scope) {
        // Set min date validation rules for end_date based on start Date
        $scope.changed = function (date, form) {
            $scope.date_moment_tool = require('moment-business-days');
            if (form.field_name == 'start_date') {
                _.each($scope.schemaForm.form, function (form) {
                    _.each(form.items, function (item) {
                        if (item.key[0] == 'end_date' &&
                            item.dateRules &&
                            (item.dateRules.dependency == 'lineItemStartDate' ||
                                item.dateRules.dependency == 'orderStartDate')
                        ) {
                            let startDate = date ? angular.copy(date) : angular.copy(item.currentDate);
                            item.minDate = setMinDate(item, startDate);
                        }
                    });
                });
            } else if (form.field_name == 'end_date') {
                _.each($scope.schemaForm.form, function (form) {
                    _.each(form.items, function (item) {
                        if (item.key[0] == 'end_date' &&
                            item.dateRules &&
                            (item.dateRules.dependency == 'lineItemStartDate' ||
                                item.dateRules.dependency == 'orderStartDate')
                        ) {
                            let startDate = $scope.model['start_date'];
                            startDate = startDate ? angular.copy(startDate) : angular.copy(item.currentDate);
                            item.minDate = setMinDate(item, startDate);
                        }
                    });
                });
            }

            form.onDateChange(date, form);
        };

        //helper function to calculate minDate
        function setMinDate(item, dateMin) {
            let numDays = item.dateRules.numDays;
            if (item.dateRules && item.dateRules.validateOn == 'after') {
                if (item.dateRules.businessDays) {
                    dateMin = $scope.date_moment_tool(dateMin.toLocaleDateString(), 'MM-DD-YYYY').businessAdd(numDays)._d;
                } else {
                    dateMin = dateMin.setDate(dateMin.getDate() + numDays);
                }
                return dateMin;
            } else if (item.dateRules && item.dateRules.validateOn == 'before') {
                if (item.dateRules.businessDays) {
                    dateMin = $scope.date_moment_tool(dateMin.toLocaleDateString(), 'MM-DD-YYYY').businessSubtract(numDays)._d;
                } else {
                    dateMin = dateMin.setDate(dateMin.getDate() - numDays);
                }
                return dateMin;
            }
        }
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'formConstant',
                    formConstantHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'formConstant',
                    formConstantHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'dynamicCalculation',
                    dynamicCalculationsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'dynamicCalculation',
                    dynamicCalculationsHtmlUrl
                );
            }
        ])
    .controller('dynamicCalculationsController', ['$scope', function ($scope) {
        $scope.isDisabled = !$scope.form.override;
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'comments',
                    commentsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'comments',
                    commentsHtmlUrl
                );
            }
        ])
    .controller('CommentsHtmlController', ['$scope', 'UserService', '$filter', '$rootScope', function ($scope, UserService, $filter, $rs) {
        $scope.mentUsersList = [];
        $scope.mentUsers = [];
        $scope.clusterId = null;
        $scope.stripFormat = function ($html) {
            // replace double quotes with single quotes for font type
            $html = $html.replace(/&quot;/g, '&#39;');
            // remove style tag from html content
            $html = $html.replace(/(<style[\w\W]+style>)/g, "");
            // remove style attribute inside the element
            $html = $html.replace(/style="[^"]*"/g, '');

            // if copy/paste is not html code, then check and convert url to hyperlink
            const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
            if (!isHTML($html)) {
                $html = $html.replace(/((http:|https:)[^\s]+[\w])/g, '<a href="$1" target="_blank">$1</a>');
            }

            $html = $html.replace(/&lt;![\s\S]*?--&gt;/g, "");
            return $html.replace(/<![\s\S]*?-->/g, "");
        }

        $scope.setup = function (element) {
            element.attr('mentio', 'mentio');
            element.attr('mentio-typed-term', 'typedTerm');
            element.attr('mentio-require-leading-space', 'true');
            element.attr('mentio-id', "'htmlContent'");
        };

        $scope.searchPeople = function (term) {
            $scope.mentUsers = $filter('filter')($scope.mentUsersList, {name: term});
        };

        $scope.getPeopleText = function (item) {
            return '@<span class="memtag primary-action-text" contenteditable="false"><strong class="tagged-user">' + item.name + '</strong><small class="hide">~' + item.id + ']</small></span>';
        };

        $scope.getPeopleTextRaw = function (item) {
            return '@[' + item.name + '~' + item.id + ']';
        };

        let getMentUsersList = function () {
            UserService.getUsers($scope.clusterId).then(function () {
                $scope.mentUsersList = UserService.users;
                _.each($scope.mentUsersList, function (userObj) {
                    userObj.name = userObj.first_name + ' ' + userObj.last_name;
                });
            }, function () {
                console.log("Error getting Watchers.");
            });
        }
        if ($scope.$parent.form && $scope.$parent.form.clientId) {
            $scope.clusterId = $scope.$parent.form.clientId;
            getMentUsersList();
        }

        let fetchTaggingUsers = $rs.$on('fetchTaggingUsers', function (event, clusterId) {
            $scope.clusterId = clusterId;
            getMentUsersList();
        });

        $scope.$on('$destroy', function () {
            fetchTaggingUsers();
        });
    }])
    .controller('FormCommentsHtmlController', ['$scope', 'UserService', '$filter', '$rootScope', function ($scope, UserService, $filter, $rs) {

        $scope.stripFormatForm = function ($html) {
            // remove style tag from html content
            $html = $html.replace(/(<style[\w\W]+style>)/g, "");

            // if copy/paste is not html code, then check and convert url to hyperlink
            const isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
            if (!isHTML($html)) {
                $html = $html.replace(/((http:|https:)[^\s]+[\w])/g, '<a href="$1" target="_blank">$1</a>');
            }

            $html = $html.replace(/&lt;![\s\S]*?--&gt;/g, "");
            return $html.replace(/<![\s\S]*?-->/g, "");
        }

        $scope.setupForm = function (element) {
            element.attr('mentio', 'mentio_form');
            element.attr('mentio-typed-term', 'typedTerm');
            element.attr('mentio-require-leading-space', 'true');
            element.attr('mentio-id', "'htmlContentForm'");
        };

        $scope.searchPeopleForm = function (term) {
            $scope.mentUsersForm = $filter('filter')($scope.mentUsersListForm, {name: term});
        };

        $scope.getPeopleTextForm = function (item) {
            return '@<span class="memtag primary-action-text" contenteditable="false"><strong class="tagged-user">' + item.name + '</strong><small class="hide">~' + item.id + ']</small></span>';
        };

        $scope.getPeopleTextFormRaw = function (item) {
            return '@[' + item.name + '~' + item.id + ']';
        };

        let getMentUsersList = function () {
            UserService.getUsers($scope.clusterId).then(function () {
                $scope.mentUsersListForm = UserService.users;
                _.each($scope.mentUsersListForm, function (userObj) {
                    userObj.name = userObj.first_name + ' ' + userObj.last_name;
                });
            }, function () {
                console.log("Error getting Watchers.");
            });
        }
        if ($scope.$parent.form && $scope.$parent.form.clientId) {
            // This clientId is actually a clusterId (yeah I know)...
            // See this line from FormService.js:
            //         commentItem.clientId = currentClusterId;
            $scope.clusterId = $scope.$parent.form.clientId;
            getMentUsersList();
        }
    }])
    .controller('TimeselectController', ['$scope', '$filter', function ($scope, $filter) {
        const field_name = $scope.form?.field_name;
        $scope.value_change_text = 'Time value changed, previous value: ';
        if ($scope.model[field_name]) {
            $scope.value_change_text += String($filter('date')($scope.model[field_name], "HH:mm"))+"  (24H)";
        } else {
            $scope.value_change_text += 'EMPTY';
        }
        
        $scope.init_timeselect_value = $scope.model[field_name]?.toTimeString();
        $scope.timeselect_value_changed = false;
        $scope.$watch('model.' + field_name, function() {
            const new_time = $scope.model[field_name]?.toTimeString();
            $scope.timeselect_value_changed = $scope.init_timeselect_value != new_time;
        });
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'timePicker',
                    timePickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'timePicker',
                    timePickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'phoneNumber',
                    phoneNumberHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'phoneNumber',
                    phoneNumberHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'currency',
                    currencyPickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'currency',
                    currencyPickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'integerPicker',
                    integerPickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'integerPicker',
                    integerPickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'decimalPicker',
                    decimalPickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'decimalPicker',
                    decimalPickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'hyperlinkPicker',
                    hyperlinkPickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'hyperlinkPicker',
                    hyperlinkPickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'percentage',
                    percentagePickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'percentage',
                    percentagePickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'timeZone',
                    timeZoneHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'timeZone',
                    timeZoneHtmlUrl
                );
            }
        ])
    .controller('timeZoneController', ['$scope', '$http', function ($scope, $http) {
        $scope.timeZoneList = [];
        $http.get('data/timeZone.json').success(function (data) {
            $scope.timeZoneList = data;
        });
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'locationPicker',
                    locationPickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'locationPicker',
                    locationPickerHtmlUrl
                );
            }
        ])
    .controller('LocationPickerController', ['$scope', function ($scope) {
        $scope.locationpickerOptions = {
            location: {
                latitude: 0,
                longitude: 0
            },
            inputBinding: {
                //latitudeInput: $('#map_latitude'),
                //longitudeInput: $('#map_longitude'),
                radiusInput: $('#map_radius'),
                locationNameInput: $('#map_address')
            },
            radius: 0,
            enableAutocomplete: true,
            defaultLocationName: $scope.form.client_address
        };
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'locationPickerFb',
                    locationPickerFbHtmlUrl

                );

                schemaFormDecoratorsProvider.createDirective(
                    'locationPickerFb',
                    locationPickerFbHtmlUrl
                );
            }
        ])
    .controller('LocationPickerController', ['$scope', function ($scope) {
        $scope.locationpickerOptions = {
            location: {
                latitude: 0,
                longitude: 0
            },
            inputBinding: {
                //latitudeInput: $('#map_latitude'),
                //longitudeInput: $('#map_longitude'),
                radiusInput: $('#map_radius'),
                locationNameInput: $('#map_address')
            },
            radius: 0,
            enableAutocomplete: true,
            defaultLocationName: $scope.form.client_address
        };
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'geoLocation',
                    geoLocationHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'geoLocation',
                    geoLocationHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'geoTargetingGoogle',
                    geoTargetingGoogleHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'geoTargetingGoogle',
                    geoTargetingGoogleHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'googleAdsBidding',
                    googleAdsBiddingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'googleAdsBidding',
                    googleAdsBiddingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'googleAdsExtension',
                    googleAdsExtensionHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'googleAdsExtension',
                    googleAdsExtensionHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'emojiPicker',
                    emojiPickerHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'emojiPicker',
                    emojiPickerHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'locationTargeting',
                    locationTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'locationTargeting',
                    locationTargetingHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'googleAdsAudTargeting',
                    audienceTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'googleAdsAudTargeting',
                    audienceTargetingHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'devicesTargeting',
                    deviceTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'devicesTargeting',
                    deviceTargetingHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'deviceCapability',
                    deviceCapabilityHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'deviceCapability',
                    deviceCapabilityHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'inventoryFilterWidget',
                    inventoryFilterHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'inventoryFilterWidget',
                    inventoryFilterHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'dfpAdUnits',
                    dfpAdUnitsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'dfpAdUnits',
                    dfpAdUnitsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'facebookAudienceTargeting',
                    fbAudienceHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'facebookAudienceTargeting',
                    fbAudienceHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'snapGender',
                    snapGenderHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'snapGender',
                    snapGenderHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'customMacroMapping',
                    customMacroMappingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'customMacroMapping',
                    customMacroMappingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'customMacroMapping2',
                    customMacroMapping2HtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'customMacroMapping2',
                    customMacroMapping2HtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'seedListMacros',
                    seedListMacrosHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'seedListMacros',
                    seedListMacrosHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'posMatchbackDetails',
                    posMatchbackDetailsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'posMatchbackDetails',
                    posMatchbackDetailsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonTeams',
                    tritonTeamsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tritonTeams',
                    tritonTeamsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'yelpCategories',
                    yelpCategoriesHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'yelpCategories',
                    yelpCategoriesHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'advancedDemographics',
                    advancedDemographicsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'advancedDemographics',
                    advancedDemographicsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'snapPredefinedAudiences',
                    snapPredefinedAudiencesHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'snapPredefinedAudiences',
                    snapPredefinedAudiencesHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'pinterestAudienceTargeting',
                    pinterestAudienceHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'pinterestAudienceTargeting',
                    pinterestAudienceHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tiktokAudienceTargeting',
                    tiktokAudienceHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tiktokAudienceTargeting',
                    tiktokAudienceHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tiktokLanguagesTargeting',
                    tiktokLanguagesHtmlUrl
                );
                schemaFormDecoratorsProvider.createDirective(
                    'tiktokLanguagesTargeting',
                    tiktokLanguagesHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tiktokDeviceTargeting',
                    tiktokDeviceHtmlUrl
                );
                schemaFormDecoratorsProvider.createDirective(
                    'tiktokDeviceTargeting',
                    tiktokDeviceHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'linkedinAudienceTargeting',
                    linkedinAudienceHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'linkedinAudienceTargeting',
                    linkedinAudienceHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'audienceSegments',
                    audienceSegmentsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'audienceSegments',
                    audienceSegmentsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'connectionTargeting',
                    connectionTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'connectionTargeting',
                    connectionTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'mobileAppsTargeting',
                    mobileApplicationHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'mobileAppsTargeting',
                    mobileApplicationHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'shoppingAdgroupSingleProduct',
                    shoppingAdgroupSingleProductHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'shoppingAdgroupSingleProduct',
                    shoppingAdgroupSingleProductHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'shoppingAdgroupMultiproduct',
                    shoppingAdgroupMultiproductHtmlUrl
                );
                schemaFormDecoratorsProvider.createDirective(
                    'shoppingAdgroupMultiproduct',
                    shoppingAdgroupMultiproductHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'imageUpload',
                    imageUploadHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'imageUpload',
                    imageUploadHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'facebookAudiences',
                    facebookAudiencesHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'facebookAudiences',
                    facebookAudiencesHtmlUrl
                );
            }
        ])
    .controller('AudienceSegmentController', ['$scope', '$http', '$filter', function ($scope, $http, $filter) {
        $scope.rootsegments = [];
        $scope.segments = [];
        $scope.segmentVal = "";
        $scope.searchLoading = false;
        var init = function () {
            $http.get("data/myfile.json").success(function (response) {
                $scope.rootsegments = response;
            });
        }
        $scope.refreshFunction = function (text, obj) {
            $scope.searchLoading = true;
            if (text.length >= 3) {
                $scope.segments = $filter('filter')($scope.rootsegments, {name: text});
            } else {
                $scope.segments = [];
            }
            $scope.searchLoading = false;
        }
        init();
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'serviceMapper',
                    serviceMapperHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'serviceMapper',
                    serviceMapperHtmlUrl
                );
            }
        ])
    .controller('ServiceMapperController', ['$scope', 'ModalService', function ($scope, ModalService) {
        $scope.updateMapping = function (model, form) {
            //form.serviceId = 2;
            var data = {
                "clientId": form.clientId,
                "serviceId": form.serviceId,
                "clusterId": form.clusterId,
                "model": model
            };
            ModalService.returnModalType('serviceMapper', data).result.then(function (formObj) {
                $scope.model['serviceMapper'] = formObj.advertiser_id;
            }, function (cancel) {
                console.log("cancel");
            });
        }
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'adGroup',
                    adGroupHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'adGroup',
                    adGroupHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'ageTragetingFb',
                    ageTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'ageTragetingFb',
                    ageTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'snapChatAgeTargeting',
                    snapChatAgeTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'snapChatAgeTargeting',
                    snapChatAgeTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'uiselect2',
                    uiselect2HtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'uiselect2',
                    uiselect2HtmlUrl
                );
            }
        ])
    .controller('UISelect2Controller', ['$scope', function ($scope) {

    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'uimultiselectcustom',
                    uiMultiSelectCustomHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'uimultiselectcustom',
                    uiMultiSelectCustomHtmlUrl
                );
            }
        ])
    .controller('UIMultiSelectCustomController', ['$scope', '$ioAlert', function ($scope, $ioAlert) {
        $scope.tagHandler = function (newTag) {
            return {
                label: newTag,
                value: newTag
            };
        }
        $scope.restrictAlphabets = function (event, label, fieldNames) {
            if (label.field_name == "dfp_adsizes" && fieldNames.creative_type != "Video" && fieldNames.creative_type != "Display") {
                const e = event;
                if ([''].indexOf(e.key) === -1) {
                    e.preventDefault();
                }
                setTimeout(function () {
                    $(':focus').blur();
                })
                $ioAlert.show('Error!', 'Please select Ad Type and try again.');
            } else if (label.field_name == "dfp_adsizes" && fieldNames.creative_type == "Video") {
                const e = event;
                if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X', 'x', 'V', 'v'].indexOf(e.key) === -1) {
                    e.preventDefault();
                }
            } else if (label.field_name == "dfp_adsizes" && fieldNames.creative_type == "Display") {
                const e = event;
                if (['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'X', 'x', ':'].indexOf(e.key) === -1) {
                    e.preventDefault();
                }
            }
        }

        $scope.onSelect = function (model, label, fieldNames) {
            if (label.field_name == "dfp_adsizes" && fieldNames.creative_type == "Video") {
                model.forEach((element, index, array) => {
                    var regExp1 = (/^\d{1,4}[X|x]\d{1,4}[V|v]$/g).test(model[index].value);
                    var regExp2 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\s][\(]Custom[\)]$/g).test(model[index].value);
                    var regExp3 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\s][\(][\s]Custom[\s][\)]$/g).test(model[index].value);
                    var regExp4 = (/^\d{1,4}[X|x]\d{1,4}[V|v][\(]Video[\/]Vast|VAST[\)][\s][\(]Custom[\)]$/g).test(model[index].value);
                    if (regExp1 || regExp2 || regExp3 || regExp4) {
                        $scope.dfpAdsizesVlidationStatus = "true";
                    } else {
                        $scope.dfpAdsizesVlidationStatus = "false";
                        if (index == 0) {
                            model.splice(index, model.length - 1);
                        } else if (index != 0) {
                            model.splice(index, 1);
                            $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                        }
                    }
                });
            } else if (label.field_name == "dfp_adsizes" && fieldNames.creative_type == "Display") {
                model.forEach((element, index, array) => {
                    var regExp1 = (/^\d{1,4}[X|x]\d{1,4}$/g).test(model[index].value);
                    var regExp2 = (/^(4|6)[:](1)$/g).test(model[index].value);
                    var regExp3 = (/^\d{1,4}[X|x]\d{1,4}[\s][\(][\s]Custom[\s][\)]$/g).test(model[index].value);
                    var regExp4 = (/^\d{1,4}[X|x]\d{1,4}[\s][\(]Custom[\)]$/g).test(model[index].value);
                    var regExp5 = (/[a-zA-Z &+,:;=?@#|'<>.^*()%!-]+$/g).test(model[index].value);
                    if (regExp1 || regExp2 || regExp3 || regExp4 || regExp5) {
                        if (model[index].value == 'x' || model[index].value == 'X' || model[index].value == ':') {
                            $scope.dfpAdsizesVlidationStatus = "false";
                            model.splice(index, 1);
                            $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                        } else {
                            $scope.dfpAdsizesVlidationStatus = "true";
                        }
                    } else {
                        $scope.dfpAdsizesVlidationStatus = "false";
                        if (index == 0) {
                            model.splice(index, model.length - 1);
                        } else if (index != 0) {
                            model.splice(index, 1);
                            $ioAlert.show('Error!', 'Please enter valid DFP Ad sizes and try again.');
                        }
                    }
                });
            }
        }

        $scope.fetchResult = function (schema, options, select) {
            if (options) {
                if (options.callback) {
                    schema.items = options.callback(schema, options, select.search);

                } else if (options.http_post) {
                    return $http.post(options.http_post.url, options.http_post.parameter).then(
                        function (_data) {
                            schema.items = _data.data;
                        },
                        function (data, status) {
                            alert("Loading select items failed (URL: '" + String(options.http_post.url) +
                                "' Parameter: " + String(options.http_post.parameter) + "\nError: " + status);
                        });
                } else if (options.http_get) {
                    return $http.get(options.http_get.url, options.http_get.parameter).then(
                        function (_data) {
                            var inputContent = [];

                            for (var x = 0; x < _data.data.length; x++) {
                                var content = _data.data[x];
                                var item = {};
                                item.value = content.lookup_value;
                                item.label = content.lookup_value;
                                inputContent.push(item);
                            }
                            schema.items = inputContent;
                        },
                        function (data, status) {
                            alert("Loading select items failed (URL: '" + String(options.http_get.url) +
                                "\nError: " + status);
                        });
                } else if (options.async && select.search && select.search.length > 2) {
                    return options.async.call(schema, options, select.search).then(
                        function (_data) {
                            var inputContent = [];
                            for (var x = 0; x < _data.data.length; x++) {
                                var content = _data.data[x];
                                var item = {};
                                item.value = content.lookup_value;
                                item.label = content.lookup_value;
                                inputContent.push(item);
                            }
                            schema.items = inputContent;
                        },
                        function (data, status) {
                            alert("Loading select items failed(Options: '" + String(options) +
                                "\nError: " + status);
                        });
                }
            }
        };
    }])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'dfpWidget',
                    dfpWidgetHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'dfpWidget',
                    dfpWidgetHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'facebookAdsLocationWidget',
                    facebookAdsLocationHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'facebookAdsLocationWidget',
                    facebookAdsLocationHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'snapchatAdsLocationWidget',
                    snapchatAdsLocationHtmlUrl
                );
                schemaFormDecoratorsProvider.createDirective(
                    'snapchatAdsLocationWidget',
                    snapchatAdsLocationHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonListenerTargeting',
                    tritonListenerTargetingHtmlUrl
                );
                schemaFormDecoratorsProvider.createDirective(
                    'tritonListenerTargeting',
                    tritonListenerTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonGeoTargeting',
                    tritonGeoTargetingHtmlUrl
                );
                schemaFormDecoratorsProvider.createDirective(
                    'tritonGeoTargeting',
                    tritonGeoTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'dayPartingTargeting',
                    dayPartingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'dayPartingTargeting',
                    dayPartingHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'adScheduleTargeting',
                    adScheduleHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'adScheduleTargeting',
                    adScheduleHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'dfpFrequencyWidget',
                    dfpFrequencyHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'dfpFrequencyWidget',
                    dfpFrequencyHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'facebookAdsFrequencyWidget',
                    facebookAdsFrequencyHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'facebookAdsFrequencyWidget',
                    facebookAdsFrequencyHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'snapChatFrequencyWidget',
                    snapChatFrequencyHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'snapChatFrequencyWidget',
                    snapChatFrequencyHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'xandrInvestFrequencyWidget',
                    xandrInvestFrequencyHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'xandrInvestFrequencyWidget',
                    xandrInvestFrequencyHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonAdsFrequencyWidget',
                    tritonAdsFrequencyHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tritonAdsFrequencyWidget',
                    tritonAdsFrequencyHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'pinterestAdsFrequencyWidget',
                    pinterestAdsFrequencyHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'pinterestAdsFrequencyWidget',
                    pinterestAdsFrequencyHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'facebookCreateAds',
                    facebookCreateAdsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'facebookCreateAds',
                    facebookCreateAdsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'multipleMappings',
                    multipleMappingsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'multipleMappings',
                    multipleMappingsHtmlUrl
                );
            }
        ])

    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'ioTextArea',
                    ioTextAreaHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'ioTextArea',
                    ioTextAreaHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'ioTextplainArea',
                    ioTextplainAreaHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'ioTextpainArea',
                    ioTextplainAreaHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'metricSelect',
                    metricSelectHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'metricSelect',
                    metricSelectHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'contentLinks',
                    contentLinksHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'contentLinks',
                    contentLinksHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'bridgeEmailTest',
                    bridgeEmailTestHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'bridgeEmailTest',
                    bridgeEmailTestHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'xandrInvestLocationWidget',
                    xandrInvestLocationHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'xandrInvestLocationWidget',
                    xandrInvestLocationHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'linksAndMainCta',
                    linksAndMainCtaHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'linksAndMainCta',
                    linksAndMainCtaHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'finalApproval',
                    finalApprovalHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'finalApproval',
                    finalApprovalHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'googleAdManagerAvailUnits',
                    googleAdManagerAvailUnitsUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'googleAdManagerAvailUnits',
                    googleAdManagerAvailUnitsUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'pinterestGeoLocation',
                    pinterestGeoLocationUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'pinterestGeoLocation',
                    pinterestGeoLocationUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'facebookPageId',
                    facebookPageIdHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'facebookPageId',
                    facebookPageIdHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonCreativeManagement',
                    tritonCreativeManagementHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tritonCreativeManagement',
                    tritonCreativeManagementHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'linkedinGeoTargeting',
                    linkedinGeoTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'linkedinGeoTargeting',
                    linkedinGeoTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonTimeTargeting',
                    tritonTimeTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tritonTimeTargeting',
                    tritonTimeTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tritonContentTargeting',
                    tritonContentTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tritonContentTargeting',
                    tritonContentTargetingHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'snapchatPixelControls',
                    snapchatPixelControlsHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'snapchatPixelControls',
                    snapchatPixelControlsHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'pinterestKeyword',
                    pinterestKeywordHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'pinterestKeyword',
                    pinterestKeywordHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'accountabilityGroupLabel',
                    accountabilityGroupLabelHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'accountabilityGroupLabel',
                    accountabilityGroupLabelHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'linkedinCampaignObjective',
                    linkedinCampaignObjectiveHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'linkedinCampaignObjective',
                    linkedinCampaignObjectiveHtmlUrl
                );
            }
        ])
    .config(
        ['schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfPathProvider',
            function (schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
                schemaFormDecoratorsProvider.addMapping(
                    'bootstrapDecorator',
                    'tiktokGeoTargeting',
                    tiktokGeoTargetingHtmlUrl
                );

                schemaFormDecoratorsProvider.createDirective(
                    'tiktokGeoTargeting',
                    tiktokGeoTargetingHtmlUrl
                );
            }
        ]);

/* Everything related to SCHEMAFORMS.IO ENDS HERE */